var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("div", { staticClass: "box" }, [
      _c("h1", { staticClass: "subtitle is-4" }, [_vm._v("Certificados")]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-3" }, [
        _vm._v(_vm._s(this.getComponentTitle)),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box is-centered" },
      [
        _c("h1", { staticClass: "subtitle is-5" }, [
          _vm._v("Datos de la solicitud"),
        ]),
        _vm._v(" "),
        _c(
          "table",
          { staticClass: "table is-bordered" },
          [
            _c("b-loading", {
              attrs: { "is-full-page": false, "can-cancel": false },
              model: {
                value: _vm.isLoading,
                callback: function ($$v) {
                  _vm.isLoading = $$v
                },
                expression: "isLoading",
              },
            }),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("th", [_vm._v("Nombre y apellido")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.nombre))]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("CUIL")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.cuil))]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("E-mail")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.email))]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Fecha solicitud")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(" " + _vm._s(_vm.dateFormat(_vm.fechaSolicitud))),
                ]),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("p", { staticClass: "title is-6 mb-3" }, [
          _vm._v(_vm._s(this.getLabelTextArea)),
        ]),
        _vm._v(" "),
        _c("b-input", {
          staticClass: "mb-5",
          attrs: { placeholder: this.getPlaceholderTextArea, type: "textarea" },
          model: {
            value: _vm.reason,
            callback: function ($$v) {
              _vm.reason = $$v
            },
            expression: "reason",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons is-right mt-6" },
          [
            _c(
              "b-button",
              { staticClass: "is-light mr-2", on: { click: _vm.goBack } },
              [_vm._v("\n        Volver\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "is-primary",
                attrs: { loading: _vm.isLoading },
                on: { click: _vm.refuseCert },
              },
              [_vm._v("\n        Continuar\n      ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }